import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_OMPLIR_DADES
} from '../../../../actions/actionTypes';

const ESTAT_INICIAL = [];

const estacions = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_OMPLIR_DADES:
            return action.estacions;

        default:
            return state;
    }
};

export default estacions;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/dades/estacions.js